<template>
  <div class="price"><Amount :data="{amounts:prices}" /></div>
</template>

<script>
export default {
  name: 'GiftPrice', 
  props: ['prices'],
}
</script>